@if (isOpen()) {
  <div
    class="fixed inset-0 z-[100] flex items-center justify-center bg-black/70 backdrop-blur-sm p-4 transition-opacity duration-150"
    [class.opacity-0]="isClosing()"
    (click)="onBackdropClick()"
  >
    <div
      class="w-full max-w-md rounded-2xl border border-card-border-border/80 bg-card-bg-default p-8 shadow-2xl shadow-black/50 transition-all duration-150"
      [class.opacity-0]="isClosing()"
      [class.scale-95]="isClosing()"
      (click)="$event.stopPropagation()"
    >
      <div class="text-center space-y-2 mb-8">
        <h1 class="text-xl font-bold tracking-tight text-text-primary">Sign in to save this view</h1>
        <p class="text-xs text-text-half-dimmed">Saved views belong to your account</p>
      </div>

      <form class="space-y-5" (ngSubmit)="handleSubmit()">
        @if (error()) {
          <div
            class="rounded-xl border border-red-500/30 bg-red-500/10 p-3.5 text-text-destructive flex items-center gap-3 text-sm"
            role="alert"
          >
            <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="shrink-0 text-red-400">
              <circle cx="12" cy="12" r="10"/>
              <line x1="12" y1="8" x2="12" y2="12"/>
              <line x1="12" y1="16" x2="12.01" y2="16"/>
            </svg>
            <p class="font-medium text-xs leading-relaxed text-red-400">{{ error() }}</p>
          </div>
        }

        <div class="space-y-4">
          <div>
            <label for="sign-in-modal-email" class="mb-1.5 block text-xs font-semibold text-text-half-dimmed uppercase tracking-wider">
              Email or Username
            </label>
            <input
              id="sign-in-modal-email"
              name="email"
              type="text"
              [(ngModel)]="email"
              required
              autocomplete="username"
              class="w-full rounded-lg border border-input-field-border-default bg-input-field-bg-default px-3.5 py-2.5 text-sm text-text-primary placeholder:text-text-dimmed transition-colors hover:border-input-field-border-hover focus:border-input-field-border-active focus:ring-1 focus:ring-input-field-focused-ring focus:outline-none"
              placeholder="you@example.com or username"
            />
          </div>

          <div>
            <label for="sign-in-modal-password" class="mb-1.5 block text-xs font-semibold text-text-half-dimmed uppercase tracking-wider">
              Password
            </label>
            <div class="relative">
              <input
                id="sign-in-modal-password"
                name="password"
                [type]="showPassword() ? 'text' : 'password'"
                [(ngModel)]="password"
                required
                autocomplete="current-password"
                class="w-full rounded-lg border border-input-field-border-default bg-input-field-bg-default px-3.5 py-2.5 pr-10 text-sm text-text-primary placeholder:text-text-dimmed transition-colors hover:border-input-field-border-hover focus:border-input-field-border-active focus:ring-1 focus:ring-input-field-focused-ring focus:outline-none"
                placeholder="••••••••"
              />
              <button
                type="button"
                class="absolute right-2.5 top-1/2 -translate-y-1/2 rounded-md p-1 text-text-dimmed transition-colors hover:text-text-primary cursor-pointer"
                (click)="togglePasswordVisibility()"
                [attr.aria-label]="showPassword() ? 'Hide password' : 'Show password'"
              >
                @if (showPassword()) {
                  <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
                    <path d="M17.94 17.94A10.07 10.07 0 0 1 12 20c-7 0-11-8-11-8a18.45 18.45 0 0 1 5.06-5.94" />
                    <path d="M9.9 4.24A9.12 9.12 0 0 1 12 4c7 0 11 8 11 8a18.5 18.5 0 0 1-2.16 3.19" />
                    <path d="M1 1l22 22" />
                    <path d="M14.12 14.12a3 3 0 1 1-4.24-4.24" />
                  </svg>
                } @else {
                  <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
                    <path d="M2 12s3-7 10-7 10 7 10 7-3 7-10 7-10-7-10-7Z" />
                    <circle cx="12" cy="12" r="3" />
                  </svg>
                }
              </button>
            </div>
          </div>
        </div>

        <div class="pt-2">
          <button
            type="submit"
            [disabled]="authService.loading()"
            class="flex w-full items-center justify-center rounded-lg bg-button-primary-default text-button-inverted-primary-default px-4 py-2.5 text-sm font-semibold hover:bg-button-primary-hover active:bg-button-primary-pressed transition-all duration-150 shadow-sm disabled:cursor-not-allowed disabled:bg-button-primary-disabled disabled:text-text-dimmed cursor-pointer"
          >
            @if (authService.loading()) {
              <span class="flex items-center gap-2">
                <span class="inline-block h-4 w-4 animate-spin rounded-full border-2 border-text-inverted-primary/30 border-t-text-inverted-primary"></span>
                Signing in...
              </span>
            } @else {
              Sign In
            }
          </button>
        </div>
      </form>
    </div>
  </div>
}
